import type {IBrand} from '@verdocs/js-sdk';

const escapeHtml = (value: string) => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/**
 * The disclosure text a brand shows when it has not written its own. Mirrors the api's
 * defaultDisclosures so the Builder preview matches what signers get: the standard e-signature
 * agreement, with the brand's name on the legal-agreement bullet and its own terms and privacy
 * pages linked when it has them.
 */
export const defaultDisclosuresFor = (brand: Pick<IBrand, 'name' | 'key' | 'terms_use_url' | 'privacy_policy_url'>) => {
  const name = escapeHtml(brand.name || brand.key);
  const possessive = name.endsWith('s') ? `${name}'` : `${name}'s`;
  const link = (url: string | null | undefined, label: string) => (url ? `<a href="${escapeHtml(url)}" target="_blank">${label}</a>` : label);

  return `<ul>
  <li>
    Agree to use electronic records and signatures, and confirm you have read the
    <a href="https://verdocs.com/en/electronic-record-signature-disclosure/" target="_blank">
      Electronic Record and Signatures Disclosure</a>.</li>
  <li>
    Agree to ${possessive} ${link(brand.terms_use_url, 'Terms of Use')}
    and confirm you have read ${possessive} ${link(brand.privacy_policy_url, 'Privacy Policy')}.
  </li>
</ul>`;
};
